var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageOffBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_894",
    "data-name": "Raggruppa 894",
    transform: "translate(342 -1065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_66_2",
    "data-name": "Componente 66 \\u2013 2",
    transform: "translate(-341 1066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_892",
    "data-name": "Raggruppa 892",
    transform: "translate(-301 -295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1517",
    "data-name": "Tracciato 1517",
    d: "M201.734,13.6a.567.567,0,0,1,0,.8l-3.6,3.6,3.6,3.6a.567.567,0,1,1-.8.8l-4-4a.565.565,0,0,1,0-.8l4-4A.566.566,0,0,1,201.734,13.6Z",
    transform: "translate(118 294)",
    fill: "#702180",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_429",
    "data-name": "Rettangolo 429",
    width: 33,
    height: 33,
    rx: 4.5,
    transform: "translate(301.5 295.5)",
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_430",
    "data-name": "Rettangolo 430",
    width: 34,
    height: 34,
    rx: 5,
    transform: "translate(301 295)",
    fill: "none",
    stroke: "#681c7f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1518",
    "data-name": "Tracciato 1518",
    d: "M201.734,13.6a.567.567,0,0,1,0,.8l-3.6,3.6,3.6,3.6a.567.567,0,1,1-.8.8l-4-4a.565.565,0,0,1,0-.8l4-4A.566.566,0,0,1,201.734,13.6Z",
    transform: "translate(118 294)",
    fill: "#702180",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_460",
    "data-name": "Rettangolo 460",
    width: 33,
    height: 33,
    rx: 4.5,
    transform: "translate(301.5 295.5)",
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_461",
    "data-name": "Rettangolo 461",
    width: 34,
    height: 34,
    rx: 5,
    transform: "translate(301 295)",
    fill: "none",
    stroke: "#681c7f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_893",
    "data-name": "Raggruppa 893",
    transform: "translate(-301 -295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1517-2",
    "data-name": "Tracciato 1517",
    d: "M201.734,13.6a.567.567,0,0,1,0,.8l-3.6,3.6,3.6,3.6a.567.567,0,1,1-.8.8l-4-4a.565.565,0,0,1,0-.8l4-4A.566.566,0,0,1,201.734,13.6Z",
    transform: "translate(118 294)",
    fill: "#702180",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_429-2",
    "data-name": "Rettangolo 429",
    width: 33,
    height: 33,
    rx: 4.5,
    transform: "translate(301.5 295.5)",
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_430-2",
    "data-name": "Rettangolo 430",
    width: 34,
    height: 34,
    rx: 5,
    transform: "translate(301 295)",
    fill: "none",
    stroke: "#681c7f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1518-2",
    "data-name": "Tracciato 1518",
    d: "M201.734,13.6a.567.567,0,0,1,0,.8l-3.6,3.6,3.6,3.6a.567.567,0,1,1-.8.8l-4-4a.565.565,0,0,1,0-.8l4-4A.566.566,0,0,1,201.734,13.6Z",
    transform: "translate(118 294)",
    fill: "#702180",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_460-2",
    "data-name": "Rettangolo 460",
    width: 33,
    height: 33,
    rx: 4.5,
    transform: "translate(301.5 295.5)",
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_461-2",
    "data-name": "Rettangolo 461",
    width: 34,
    height: 34,
    rx: 5,
    transform: "translate(301 295)",
    fill: "none",
    stroke: "#681c7f",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageOffBack);
export default __webpack_public_path__ + "static/media/page-off-back.a29feb508355652acba61e5da279d049.svg";
export { ForwardRef as ReactComponent };